import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CommonModule, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {AppRoutingModule} from './app-routing.module';
import {ToasterModule} from 'angular2-toaster';
import {SharedComponentModule} from './shared-component/shared-component.module';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {CdkTableModule} from '@angular/cdk/table';

import {HttpInterceptorService} from './shared-component/http-interceptor/http-interceptor.service';
import {FullComponent} from './layouts/full/full.component';
import {BlankComponent} from './layouts/blank/blank.component';
import {NavigationComponent} from './shared/header-navigation/navigation.component';
import {SidebarComponent} from './shared/sidebar/sidebar.component';
import {AppComponent} from './app.component';

import {PERFECT_SCROLLBAR_CONFIG} from 'ngx-perfect-scrollbar';
import {PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
import {WindowRefService} from './bitly/terms-of-service/window.service';
import {NgHttpLoaderModule} from 'ng-http-loader';
import { TermsConditionsBitlyComponent } from './terms-conditions-bitly/terms-conditions-bitly.component';
import { TermsConditionsAcceptedMessageComponent } from './terms-conditions-accepted-message/terms-conditions-accepted-message.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true
};

@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    BlankComponent,
    NavigationComponent,
    SidebarComponent,
    TermsConditionsBitlyComponent,
    TermsConditionsAcceptedMessageComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    NgbModule.forRoot(),
    PerfectScrollbarModule,
    AppRoutingModule,
    SharedComponentModule,
    ReactiveFormsModule,
    ToasterModule.forRoot(),
    InfiniteScrollModule,
    CdkTableModule,
    NgHttpLoaderModule.forRoot()
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }, {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    }, {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    WindowRefService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
